// extracted by mini-css-extract-plugin
module.exports = {"root":"e_qA","recognition":"e_rA","clue":"e_sA"};